import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as accountsReducer from "containers/Accounts/reducer";

import ModelBox from "components/Business/ModelBox/ModelBox";

class ModelBoxContainer extends React.PureComponent {
  render() {
    return <ModelBox {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  const retId = ownProps.runId;

  return {
    initRun: () => {},
    updateCurrentStep: (stepId) => dispatch(businessReducer.updateCurrentStep(id, stepId)),
    updateShowBusiness: (showBusiness) => dispatch(setupReducer.updateShowBusiness(retId, showBusiness)),
    updateShowImpact: (showImpact) => dispatch(setupReducer.updateShowImpact(retId, showImpact)),
    updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(id, timePeriod)),
    deploy: () => dispatch(projectReducer.deploy(id, true)),
    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue)),
    selectStep: (step) => dispatch(businessReducer.selectStep(ownProps.id, step)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),

    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.id) !== Number(id)) {
    optimized = projectReducer.getOptimized(state, id);
  }

  const overallRunId = projectReducer.getOverallRunId(state, id);

  const runId =
    ownProps.runId !== undefined
      ? ownProps.runId
      : optimized && optimized.innerId !== undefined
        ? optimized.innerId
        : id;

  const overallOptimized = overallRunId === runId ? optimized : projectReducer.getOptimized(state, id, overallRunId);

  const modelGroups = projectReducer.getModelGroups(state, id);

  const isOverallSegment = projectReducer.getIsOverallSegment(state, id, runId);

  const project = projectReducer.getProject(state, id);

  const accountId = project?.account_id;

  return {
    id: id,
    runId: runId,
    isDone: projectReducer.getIsDone(state, id),
    currentStep: businessReducer.getCurrentStep(state, ownProps.id),

    isOverallSegment: isOverallSegment,

    hasErrors: projectReducer.getHasErrors(state, id, runId),
    errorMessages: runReducer.getErrors(state, runId),

    modelGroups: modelGroups,
    isScenarioDeployed: projectReducer.getIsScenarioDeployed(state, id),
    project: project,
    account: accountsReducer.getAccount(state, accountId),
    optimized: optimized,
    overallOptimized: overallOptimized,

    isTraining: projectReducer.getIsTraining(state, id),

    segmentConfusionMatrices: projectReducer.getSegmentConfusionMatrices(state, id),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),
    revenueLabel: setupReducer.getAdvancedRevenueLabel(state, runId),
    profitLabel: setupReducer.getNetImpactLabel(state, runId),
    costLabel: setupReducer.getAdvancedCostLabel(state, runId),
    truePositiveLabel: setupReducer.getTruePositiveLabel(state, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId),
    rSetup: setupReducer.getSetup(state, runId),

    setup: optimized && optimized.setup ? optimized.setup : setupReducer.getSetup(state, runId),
    overallSetup: setupReducer.getSetup(state, overallRunId),
    model: projectReducer.getCapModel(state, id, runId),
    modelList: runReducer.getTransformedSortedModels(state, runId),
    ignoredModels: setupReducer.getIgnoredModels(state, runId),
    modelCount: projectReducer.getModelCount(state, id, runId),
    primaryBusinessConstraintType: setupReducer.getPrimaryBusinessConstraintType(state, id, runId),
    allBusinessConstraints: setupReducer.getAllBusinessConstraints(state, id),

    showImpact: setupReducer.getShowImpact(state, id),

    nextModelsHoverNode: nextModelsReducer.getHoverNode(state, ownProps.nextId),

    selectedScenario: projectReducer.getSelectedScenario(state, id),
    allScenarios: projectReducer.getAllScenarios(state, id),
    optimizer: projectReducer.getOptimizer(state, id),
    currentCostExcludingBaselines: projectReducer.getCurrentSpendExcludingBaselines(state, id, overallRunId),
    currentRevenueExcludingBaseline: projectReducer.getCurrentRevenueExcludingBaselines(state, id, overallRunId),
    currentProfitExcludingBaseline: projectReducer.getCurrentProfitExcludingBaselines(state, id, overallRunId),

    baselineCountContinuous: setupReducer.getBaselineCountContinuous(state, runId, id),
    baselineValueContinuous: setupReducer.getBaselineValueContinuous(state, runId, id),

    expectedCountContinuous: setupReducer.getExpectedCountContinuous(state, runId, id),
    expectedValueContinuous: setupReducer.getBaselineValueContinuous(state, runId, id),

    continuousPercent: setupReducer.getCurrentContinuousPercent(state, runId, id),
    continuousCurrentProfit: setupReducer.getCurrentContinuousProfit(state, runId, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelBoxContainer);
